/**
 * AboutPage — The Connekted.in origin story
 *
 * Narrative: Founder attended an EU startup summit, exchanged dozens of
 * paper cards, lost half, couldn't remember conversations. Built Connekted.in
 * as the solution — a free digital business card that never gets lost.
 *
 * NO mention of LinkedIn or any competitor. This is a standalone origin story.
 */
import StaticPageLayout from './StaticPageLayout';

export default function AboutPage() {
  return (
    <StaticPageLayout title={<>About <em style={{ fontStyle: 'italic', color: 'var(--brand)' }}>connekted in</em>.</>}>

      <h3>The story</h3>
      <p>
        In early 2025, the co-founder of Bite Binary attended a startup summit in Munich.
        Over three days, he exchanged business cards with investors, founders, and engineers
        from across the European Union. By the time he returned home, half the cards were
        crumpled in a coat pocket, a few had been left on a conference table, and the rest
        were scattered across a carry-on bag. Worse still, he could barely remember which
        conversation belonged to which card.
      </p>
      <p>
        It was a problem hiding in plain sight. Despite the world going digital,
        professional introductions still relied on a 7 × 5 cm piece of paper — easily
        lost, impossible to update, and disconnected from any follow-up system.
      </p>
      <p>
        That frustration became the seed for Connekted.in: a free digital business card
        platform that replaces the paper ritual with something that actually works.
      </p>

      <h3>What we built</h3>
      <p>
        Connekted.in gives every professional a personal QR code and a clean scan page.
        When someone scans your code, they see exactly the information you choose to share —
        your name, role, contact details, and social links. They can save your details to
        their phone in one tap. You get a real-time notification telling you who scanned,
        when, and where.
      </p>
      <p>
        No paper. No app install required for the person scanning. No lost connections.
      </p>

      <h3>Why free</h3>
      <p>
        We believe the basic act of exchanging contact information should cost nothing.
        Connekted.in is free to use — create your card, get your QR code, share it at
        your next event. As we grow, premium features for teams and enterprises will
        sustain the platform, but the core product will always remain free.
      </p>

      <h3>Built by Bite Binary</h3>
      <p>
        Connekted.in is a product of{' '}
        <a
          href="https://bitebinary.com/#about"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: 'var(--brand)', textDecoration: 'underline' }}
        >
          Bite Binary
        </a>
        , a software studio based in the European Union. We build tools that solve real
        problems with clean design and thoughtful engineering.
      </p>

      <h3>Contact</h3>
      <p>
        Questions, feedback, or partnership enquiries — reach us at{' '}
        <a href="mailto:hello@connektedin.com" style={{ color: 'var(--brand)' }}>
          hello@connektedin.com
        </a>.
      </p>
    </StaticPageLayout>
  );
}
